import * as actions from '../services'
import * as types from './mutations-types'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import { t } from 'src/utils/form'

export const pay = (context, payload) => {
  return actions.pay(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(types.setInvoice, response.data.invoice)
    } else {
      context.commit(addFlash, { message: t(context, 'application.alert.payment_failed') + '<br>' + (response.data.error.message || response.data.error['response'][0]), type: 'ls-alert-danger' })
    }
    return response
  })
}

export const getSplits = (context, payload) => {
  return actions.splits(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(types.setSplits, response.data.transaction.data_response.payment_methods)
    }
    return response
  })
}

export const getYapayBalance = (context, payload) => {
  return actions.getYapayBalance(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(types.setYapayData, response.data)
    } else {
      context.commit(addFlash, { message: response.data[0].message, type: 'ls-alert-warning' })
    }
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/payments/vuex/actions.js